import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';

import {getPersianErrorCode} from '../../../global/helpers/ErrorCodes/ErrorCode';
import {ErrorResponse} from '../patchDirectLoanRequest/usePatchDirectLoanRequest';

import {
  IPostSignLoanContractPayload,
  postSignLoanContract,
} from './postSignLoanContract';

interface UsePostSignLoanContractProps extends IPostSignLoanContractPayload {
  onSuccess?: () => void;
  onError?: (
    error: AxiosError<
      ErrorResponse & {
        message?: string;
        messages?: string[];
      }
    >,
  ) => void;
}

const usePostSignLoanContract = ({
  loan_request_guid,
  onSuccess,
  onError,
}: UsePostSignLoanContractProps) => {
  const {mutate, isLoading} = useMutation({
    mutationFn: () =>
      postSignLoanContract({
        loan_request_guid,
      }),

    onSuccess: () => {
      onSuccess?.();
    },

    onError: error => {
      const axiosError = error as AxiosError<
        ErrorResponse & {
          message?: string;
          messages?: string[];
        }
      >;

      const errorCode = axiosError.response?.data?.error_code;

      if (errorCode) {
        toast.error(getPersianErrorCode(errorCode));

        return;
      }

      const message =
        axiosError.response?.data?.message ||
        axiosError.response?.data?.messages?.[0];

      if (message) {
        const txt = document.createElement('textarea');

        txt.innerHTML = message;

        toast.error(txt.value);
      }

      onError?.(axiosError);
    },
  });

  return {mutate, isLoading};
};

export default usePostSignLoanContract;
